package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.button.IconButton
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_pencil
import inspection.composeapp.generated.resources.ic_trash

@Composable
fun ContentItemNotes(
    notes: String,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onEditNotes: () -> Unit,
    onDeleteNotes: () -> Unit
) {
    AnimatedVisibility(
        visible = notes.isNotEmpty(),
        enter = fadeIn(),
        exit = fadeOut()
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
                .background(
                    color = color.surface.neutral.subtlest.default,
                    shape = RoundedCornerShape(dimension.radius.md)
                )
                .padding(dimension.spacing.space3),
            verticalArrangement = Arrangement.spacedBy(dimension.spacing.space1)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement =
                    Arrangement.spacedBy(
                        dimension.spacing.space2,
                    ),
                verticalAlignment = Alignment.CenterVertically
            ) {
                TextBodySmall(
                    text = "Notes",
                    bold = true,
                    modifier = Modifier.weight(1f)
                )

                IconButton(
                    icon = Res.drawable.ic_pencil,
                    backgroundColor = Color.Transparent,
                    tint = color.icon.subtle,
                    onClick = {
                        onEditNotes()
                    }
                )

                IconButton(
                    icon = Res.drawable.ic_trash,
                    backgroundColor = Color.Transparent,
                    tint = color.icon.error.default,
                    onClick = {
                        onDeleteNotes()
                    }
                )
            }

            TextBodySmall(text = notes)
        }
    }
}
